/**
 * The complaints module's routes, owned by the feature. D5.
 *
 * The paths stay `/reclamos` and `/reclamos/:id` even though the feature is `complaints`: they are
 * what the sidebar links to and what a bookmark holds. The English name is for the code, the
 * Spanish one is what operators see.
 */
import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const ComplaintsPage = lazy(() => import('./ComplaintsPage'));
const ReclamoDetail = lazy(() => import('./ReclamoDetail'));

export const complaintsRoutes: RouteObject[] = [
    { path: 'reclamos', element: <ComplaintsPage /> },
    { path: 'reclamos/:id', element: <ReclamoDetail /> },
];
